import { render, staticRenderFns } from "./CreateUserAccount.vue?vue&type=template&id=710e96a9&scoped=true&"
import script from "./CreateUserAccount.vue?vue&type=script&lang=js&"
export * from "./CreateUserAccount.vue?vue&type=script&lang=js&"
import style0 from "./CreateUserAccount.vue?vue&type=style&index=0&id=710e96a9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710e96a9",
  null
  
)

export default component.exports